export const randomStringEnumValue = <T extends object>(
  enumeration: T,
): T[keyof T] => {
  const values = Object.keys(enumeration) as T[keyof T][];
  const enumKey = values[Math.floor(Math.random() * values.length)];
  return enumeration[enumKey as keyof T];
};

export const randomEnumValue = <T extends object>(
  enumeration: T,
): T[keyof T] => {
  const values = Object.keys(enumeration) as T[keyof T][];
  const enumKey = values[Math.floor((Math.random() * values.length) / 2)];
  return enumeration[enumKey as keyof T];
};

export const isSomeEnum =
  <T extends object>(e: T) =>
  (token: unknown): token is T[keyof T] =>
    Object.values(e as object).includes(token as T[keyof T]);

export const getNextEnumValue = <T extends Record<string, string | number>>(
  enumObj: T,
  currentValue: T[keyof T],
): T[keyof T] => {
  const values = Object.values(enumObj) as T[keyof T][];
  const index = values.indexOf(currentValue);
  const nextIndex = (index + 1) % values.length;
  return values[nextIndex];
};

export const enumToSelectList = <T extends string>(
  enumObj: Record<string, T>,
): { value: T; label: string }[] =>
  Object.values(enumObj)
    .filter((value): value is T => typeof value === "string")
    .map(value => ({ value, label: value }));
